module.exports = __webpack_public_path__ + "preloader.full.ce9388defd6a91d07b1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/preloader/preloader.full.png
// module id = 1031
// module chunks = 3